import { TaggedSlugEntityPublicApiService } from './taggedSlugEntityPublicApiService';
import { WhitePaper } from '@models/whitePaper';

export class WhitePaperPublicService extends TaggedSlugEntityPublicApiService<WhitePaper> {
    constructor() {
        super('/api/white-paper');
    }
}
